// ##########################################################################################
// Gallery Scroll Cacher
// ==========================================================================================
// The Scroll Cacher object, defined by the return value of the function below, is a
// submodule of the JDA gallery module. This submodule is responsible for storing a users
// current scroll position when they click on an entry from the gallery page and navigate
// away from it, so that this position may be restored when they click on the 'Back' button.
// It is also responsible for purging this stored value under the relevant circumstances.
// ##########################################################################################

var galleryModule = app.mediator.getModule(MODULE_NAME__GALLERY);
galleryModule.injectSubModule('scrollCacher', function() {

	// =======================================================================
	// Module data
	// =======================================================================

	var scrollPositionStorageKey = 'galleryScrollPosition';

	// =======================================================================
	// Module functions
	// =======================================================================

	function store(itemPositionInGallery) {
        var offset = $(window).scrollTop();
        var currentFilterData = galleryModule.getSubModule('dataManager').getFiltersDto();
        if (localStorage) {
            localStorage.setItem(scrollPositionStorageKey, JSON.stringify({
                scrollPosition: offset,
                itemIdx: itemPositionInGallery,
                currentFilterData: currentFilterData,
                url: window.location.pathname
            }));
        }
	}

	function get() {
		if (!localStorage) return null;
		var data = localStorage.getItem(scrollPositionStorageKey);
		return data ? JSON.parse(data) : null;
	}

	function purge() {
		if (localStorage) localStorage.setItem(scrollPositionStorageKey, null);
	}

    // The pull function essentially works like the get function does,
    // but it simultaneously purges the persisted data that it returns.
    function pull() {
        var data = get();
        purge();
        return data;
    }

	// =======================================================================
	// Public API
	// =======================================================================

	return {
		store: store,
		get: get,
        pull: pull,
		purge: purge
	};

});